module.exports = __webpack_public_path__ + "img/jumbotron_under.fea0c85d.jpg";